__webpack_require__.p = "/konfigurator/";